export default "__VITE_ASSET__DHLx5QN3__"